export enum CompareEnum {
  Kompas = 'kompas'
}
